"use client";

import { useState, useRef } from "react";
import { PlayIcon } from "../../../icons";

interface VideoPlayerProps {
  attachments: {
    video?: string;
  };
}

export default function VideoPlayer({ attachments }: VideoPlayerProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoPlay = () => {
    setIsPlaying(true);
  };

  const handleVideoPause = () => {
    setIsPlaying(false);
  };

  return (
    <>
      {attachments?.video && (
        <div className="relative w-full h-72 rounded-xl-10 mr-4 mb-4 overflow-hidden">
          <video
            ref={videoRef}
            className="object-contain w-full h-full rounded-xl-10"
            controls
            onPlay={handleVideoPlay}
            onPause={handleVideoPause}
          >
            <source src={attachments.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <button
            onClick={handlePlayPause}
            className="absolute inset-0 m-auto w-16 h-16 flex items-center justify-center  bg-opacity-0 rounded-full transition-opacity hover:bg-opacity-100"
            aria-label={isPlaying ? "Pause video" : "Play video"}
          >
            {!isPlaying && (
              <div onClick={handlePlayPause}>
                <PlayIcon />
              </div>
            )}
          </button>
        </div>
      )}
    </>
  );
}
